import { changePage, getClaims } from 'feature/claims/claimsSlice';
import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setSortingValues } from 'feature/form/formSlice';
import { useDebounce } from 'hooks/debouncer.hook';
import { AppDispatch, RootState } from 'store/store';
import { buildClaimsFilterParams } from 'utils/utils';
import ClaimListFooter from './ClaimListFooter.component';
import Claims from './Claims';

const ViewClaims = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { claimsStatuses, sortingFields, sortingDirections } = useSelector(
		(store: RootState) => store.form,
	);
	const form = useSelector((store: RootState) => store.form);

	useEffect(() => {
		dispatch(
			setSortingValues({
				name: 'serviceDate,externalClaimId',
				value: 'DESC,DESC',
			}),
		);

		return () => {
			dispatch(changePage(1));
		};
	}, [dispatch]);

	const { queryParams: searchParams } = buildClaimsFilterParams(form);
	const searchParamsDeb = useDebounce(searchParams);

	useEffect(() => {
		dispatch(changePage(1));
		dispatch(getClaims(''));
	}, [dispatch, searchParamsDeb, sortingFields, sortingDirections]);

	if (claimsStatuses.length === 0) {
		return null;
	}

	return (
		<Fragment>
			<Claims />
			<ClaimListFooter />
		</Fragment>
	);
};

export default ViewClaims;
